import React, { type CSSProperties, type ImgHTMLAttributes } from 'react';

import { FlagImage } from 'react-international-phone';

export type FlagImgProps = {
    size?: CSSProperties['width'];
    iso2: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>;

export const FlagImg = ({ iso2, size, ...rest }: FlagImgProps) => {
    const flagSrc = `/static/node/images/flags/${iso2}.svg`;
    return <FlagImage iso2={iso2} src={flagSrc} size={size} {...rest} aria-hidden="true" />;
};
